import { Action, createReducer, on } from '@ngrx/store';
import { IProductSolutionResponse } from '../models/product-solutions.model';
import * as productSolution from '../actions';

export const getProductSolutionsFeatureKey = 'getProductSolutions';

export interface State {
  loaded: boolean;
  error?: Error | any;
  getProductSolutions: IProductSolutionResponse;
}

export const initialState: State = {
  loaded: false,
  error: undefined,
  getProductSolutions: undefined
};

export const reducer = createReducer(
  initialState,
  on(
    productSolution.loadGetProductSolutions,

    state => state
  ),
  on(productSolution.loadGetProductSolutionsSuccess, (state, action) => ({
    ...state,
    getProductSolutions: action.response,
    loaded: true
  })),

  on(productSolution.loadGetProductSolutionsFailure, (state, { error }) => ({
    ...state,
    error
  }))
);

export const selectProductSolutions = (state: State) => state.getProductSolutions;
export const selectProductSolutionsLoaded = (state: State) => state.loaded;
export const selectProductSolutionsError = (state: State) => state.error;
